import { css } from '@emotion/core'
import React from 'react'

interface Props {
  id: string
  ratio: number
  className?: string
}

const YoutubeVideo: React.FunctionComponent<Props> = ({ id, ratio, className }) => {
  return (
    <div style={{ position: 'relative', overflow: 'hidden' }} className={className}>
      <div style={{ width: '100%', paddingBottom: `${((1 / ratio) * 100).toFixed(4)}%` }} />
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${id}`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        css={iframeStyle}
      />
    </div>
  )
}

export default YoutubeVideo

const iframeStyle = css`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`
